
import { Component, Vue } from 'vue-property-decorator'
import AppHeader from '@/components/AppHeader.vue'
import AppLoadingCircular from '@/components/AppLoadingCircular.vue'
import AppTable from '@/components/AppTable.vue'
import QueriesHeader from '@/components/QueriesHeader.vue'
import QueriesSavedQueries from '@/components/QueriesSavedQueries.vue'
import QueryBox from '@/components/QueryBox.vue'
import { Tabs } from '@/stores/modules/QueriesModule'

@Component({
    name: 'Queries',
    components: {
        AppHeader,
        QueriesHeader,
        QueryBox,
        AppLoadingCircular,
        QueriesSavedQueries,
        AppTable,
    },
})

export default class Queries extends Vue {
    get isLoading(): boolean {
        return this.$store.state.query.isLoading
    }

    get result(): object[] {
        return this.$store.state.query.result
    }

    get headers(): string[] {
        const rows =  this.$store.state.query.result

        if (rows[0]) {
            return Object.keys(rows[0])
        } else {
            return []
        }
    }

    get showNewQuery() {
        return this.$store.state.query.selectedTab === Tabs.NEW_QUERY
    }

    get showSavedQueries() {
        return this.$store.state.query.selectedTab === Tabs.SAVED_QUERIES
    }

    public mounted() {
        this.$store.dispatch('query/getQueries')
    }
}
